import { render } from "./MobileSubpageHeader.vue?vue&type=template&id=0cdb6f83&scoped=true"
import script from "./MobileSubpageHeader.vue?vue&type=script&lang=js"
export * from "./MobileSubpageHeader.vue?vue&type=script&lang=js"

import "./MobileSubpageHeader.vue?vue&type=style&index=0&id=0cdb6f83&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdb6f83"]])

export default __exports__